import React, { useRef, useEffect, useState, useCallback, useMemo } from "react";
// import { useNavigate, NavLink } from "react-router-dom";

import Ticker from 'react-ticker';

import { TokenToolbar } from "../../components/Dex/TokenToolbar";

import { useAuth } from "../../hooks/useAuth";

import { useCore } from "../../hooks/useCore";
import { useWallet } from "../../hooks/useWallet";
import { useNavigator } from "../../hooks/useNavigator";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import ReactTooltip from 'react-tooltip';
import Typewriter from 'typewriter-effect';

import { Layout } from "../../components/Layout";
import logo0x from "../../icons/logo_0xdex_faded.png";

import { GridCanvas } from "../../components/Home/GridCanvas";
import { CanvasCircle } from "../../components/Home/CanvasCircle";

import { TickerBlock } from "../../components/Dex/TickerBlock";
import { ContractAddressToolbar } from "../../components/Dex/ContractAddressToolbar";
import { FeatureTable } from "../../components/Layout/FeatureTable";

import { formatCurrency, condenseZeros, formatPercent, formatCurrencyScale, formatNumberScale } from "../../utils/currency";
import { dataProviderLogos, heroImages, tgSnipersLogos, memePhotos, dashboardFeatures } from "../../utils/data";
import { addCommas } from "../../utils/tools";

import {ReactComponent as NeuralIcon} from '../../icons/svgs/neuralnetwork.svg';
import {ReactComponent as UniswapIcon} from '../../icons/svgs/logo_uniswap_wide.svg';
import {ReactComponent as NftIcon} from '../../icons/svgs/icon_nft.svg';
import {ReactComponent as CoinIcon} from '../../icons/svgs/icon_coin.svg';
import {ReactComponent as WalletIcon} from '../../icons/svgs/wallet.svg';



import {isMobile} from 'react-device-detect';

var parse = require('html-react-parser');

export function Website() {

    const [tkey, setTKey] = useState(0);

    

    // Violet	148, 0, 211 #9400D3
    // Indigo	75, 0, 130	#4B0082
    // Blue	0, 0, 255	#0000FF
    // Green	0, 255, 0	#00FF00
    // Yellow	255, 255, 0	#FFFF00
    // Orange	255, 127, 0	#FF7F00
    // Red	255, 0 , 0	#FF0000

    let navigate = useNavigate();

    const [tokenAddress, setTokenAddress] = useState('0xB2Cfc9A054562BCfD854daD55a99E8BC8085A480');
    const [pairAddress, setPairAddress] = useState('0xfFBc8746159cd0b7cD4ad70Bcb5662c1072682F5');

    const { windowDimensions, websiteLoaded, handleWebsiteLoaded, accessAllowed, version } = useCore();
    const { btcPrice, ethPrice, solPrice } = useWallet();

    const [memes, setMemes] = useState([]);

    // useEffect(() => {
    //     setTKey(prevKey => prevKey + 1); // Update key when the variable changes
    // }, [ethPrice,btcPrice]);


    const [tMouseOver, setTMouseOver] = useState(false);
    const [cMouseOver, setCMouseOver] = useState(false);

    const { screens } = useNavigator();

    const [mouseX, setMouseX] = useState(0);
    const [mouseY, setMouseY] = useState(0);

    const [scrollPosition, setScrollPosition] = useState(0);

    const [heroImage, setHeroImage] = useState(null);

    const timelineRef = useRef(null);
    const scrollPos = useRef(0);

    const [timelineLineHeight, setTimelineLineHeight] = useState(0);

    const [p1Width, setP1Width] = useState(0);
    const [p1Height, setP1Height] = useState(0);

    const animateRefs = [
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
    ];

    const parallaxRefs = [
        useRef(null)
    ];

    const footerImageRef = useRef(null);

    const timelineLineRef = useRef(null);
    const lineArrowRef = useRef(null);

    const socialLinks = {

        telegram:'https://t.me/ZeroXDexPORTAL',
        twitter:'https://x.com/0xdexai',
        // instagram:'https://instagram.com/dexter',
        // website:'https://0xdex.ai',
        // discord:'discord.dexter',

    }

    useEffect(() => {
        if(heroImage && accessAllowed){
            const image = new Image();
            image.src = require(`../../media/photos/${heroImage}`);

            image.onload = () => {
                setP1Width(image.width);
                setP1Height(image.height);
            };
        }

    }, [heroImage, accessAllowed]);


    const imageRef = useRef();


    useEffect(() => {
        ReactTooltip.rebuild();

        document.body.classList.add('inWebsite');

        const pageWrapper = document.querySelector('.page-wrapper');

        if(pageWrapper !== undefined && pageWrapper){

            function moveImage(event) {
                // const { clientX: x, clientY: y } = isMobile ? event.touches[0] : event; // Use the first touch's coordinates
                const { clientX: x, clientY: y } = event;
                let mx = x / windowDimensions.width;
                let my = y / windowDimensions.height;
                setMouseX(mx);
                setMouseY(my);
                const { offsetWidth: width, offsetHeight: height } = imageRef.current !== undefined ? imageRef.current : 0;

                const sp = pageWrapper.scrollTop / pageWrapper.clientHeight;

                let spp = scrollPosition/windowDimensions.height;
                // console.log(sp)
                let ytemp = spp + (my-spp);

                if(imageRef.current !== undefined){
                    imageRef.current.style.transform = `translate(${-((20 * x) / width)}px, ${-((40 * sp))}px)`;
                }

            }

            // Add event listeners for both mousemove and touchmove events
            if ('ontouchstart' in window) {
                // For touch devices, remove mousemove event listener and add touchmove event listener
                document.removeEventListener('mousemove', moveImage);
                // document.addEventListener('touchmove', moveImage);
            } else {
                // For non-touch devices, remove touchmove event listener and add mousemove event listener
                // document.removeEventListener('touchmove', moveImage);
                document.addEventListener('mousemove', moveImage);
            }

            const rindex = Math.floor(Math.random() * heroImages.length);
            setHeroImage(heroImages[rindex]);

            return () => {
                // Cleanup function to remove event listeners on component unmount
                document.removeEventListener('mousemove', moveImage);
                // document.removeEventListener('touchmove', moveImage);
            };
        }
    }, [ accessAllowed ]);


    // useEffect(() => {
    //
    //     ReactTooltip.rebuild();
    //
    //     function moveImage(event) {
    //       const { clientX: x, clientY: y } = event;
    //       setMouseX(x/windowDimensions.width);
    //       setMouseY(y/windowDimensions.height);
    //       const { offsetWidth: width, offsetHeight: height } = imageRef.current;
    //       imageRef.current.style.transform = `translate(${-((20*x) / width)}px, ${-((20*y) / height)}px)`;
    //     }
    //
    //     document.addEventListener('mousemove', moveImage);
    //
    //     const rindex = Math.floor(Math.random()*heroImages.length);
    //     console.log(rindex);
    //     setHeroImage(heroImages[rindex]);
    //
    //     return () => {
    //       document.removeEventListener('mousemove', moveImage);
    //     };
    //
    // }, []);


    useEffect(() => {

        const memeRandom = new Set();
        while (memeRandom.size < 3) {
            const randomNum = Math.floor(Math.random() * memePhotos.length);
            memeRandom.add(randomNum);
        }
        let mr = Array.from(memeRandom)
        let m = [];
        for(var i=0;i<mr.length;i++){
            m.push(memePhotos[mr[i]]);
        }
       
        setMemes(m);

        function handleLoad() {
            // This function will be called once everything is loaded
            handleWebsiteLoaded(true);
        }

        window.addEventListener('load', handleLoad);

        // Cleanup function to remove the event listener
        return () => {
            window.removeEventListener('load', handleLoad);
        };
    }, []);


    useEffect(() => {

        const pageWrapper = document.querySelector('.page-wrapper');
        const mHeader = document.getElementById("mainheader");

        const slideIn = () => {

            const scrollIndex = (pageWrapper.scrollTop / pageWrapper.clientHeight).toFixed(2);
            // console.log(scrollIndex,pageWrapper.scrollTop,pageWrapper.clientHeight);
            setScrollPosition(scrollIndex);

            let totalIndex = (pageWrapper.scrollHeight / window.innerHeight).toFixed(2);
            // console.log(scrollIndex, totalIndex);
            if(!mHeader.classList.contains('show') && ( scrollIndex > .64 || scrollIndex < totalIndex - 1.4)){
                mHeader.classList.add('show');
            }

            if(mHeader.classList.contains('show') && (scrollIndex < .64 || scrollIndex > totalIndex - 1.4)){
                mHeader.classList.remove('show');
            }


            if(imageRef.current !== undefined){
                const { offsetWidth: width, offsetHeight: height } = imageRef.current;
                imageRef.current.style.transform = `translate(${-((20 * mouseX) / width)}px, ${-((40 * scrollIndex))}px)`;
            }

            // for features fade in/slide ins
            animateRefs.forEach((animateRef) => {
                const container = animateRef.current;
                if (container) {
                    const containerTop = container.getBoundingClientRect().top;
                    const containerBottom = container.getBoundingClientRect().bottom;
                    // const inViewport = containerTop < window.innerHeight && containerBottom >= 0;
                    const isPast120px = containerTop < window.innerHeight - 220;
                    if (isPast120px) {
                        container.classList.add('animate-in');
                    } else {
                        container.classList.remove('animate-in');
                    }
                }
            });


            parallaxRefs.forEach((pRef, i) => {
                const photo = pRef.current;
                if(photo){

                    const pTop = photo.getBoundingClientRect().top;
                    const pBottom = photo.getBoundingClientRect().bottom;
                    // console.log(pTop,pBottom,p1Width,p1Height);
                    // console.log(pTop,pBottom,window.innerHeight)
                    if(pTop < window.innerHeight && pBottom > 0){
                        let range = (window.innerHeight - pTop) + pBottom;

                        const aspectRatio = p1Width / p1Height;
                        const containerWidth = window.innerWidth;
                        const photoHeight = containerWidth / aspectRatio;

                        let percentRange = 1 - pBottom/range;
                        let displayHeight = pBottom - pTop;
                        let movementHeight = photoHeight - displayHeight;
                        // console.log(percentRange);
                        // const containerTop = photo.offsetTop;

                        // console.log(photoHeight, displayHeight, movementHeight);
                        // setImageHeight(containerHeight);
                        // console.log
                        // console.log(window.pageYOffset,scrollPosition,pTop,photo.offsetTop);
                        const newBgPosition = movementHeight > 0 ? `50% ${(0 - percentRange*movementHeight)}px` : 'center';
                        photo.style.backgroundPosition = newBgPosition;
                    }
                }
            });


            if(footerImageRef.current && footerImageRef.current !== undefined){
                const { offsetWidth: width, offsetHeight: height } = footerImageRef.current;

                const fTop = footerImageRef.current.getBoundingClientRect().top;
                const fBottom = footerImageRef.current.getBoundingClientRect().bottom;
                // console.log(fTop,fBottom,p1Width,p1Height);
                // console.log(pTop,pBottom,window.innerHeight)
                if(fTop < window.innerHeight && fBottom > 2000){

                    let range = (window.innerHeight - fTop) + fBottom;

                    const aspectRatio = p1Width / p1Height;
                    const containerWidth = window.innerWidth;
                    const photoHeight = containerWidth / aspectRatio;

                    let percentRange = 1 - fBottom/range;
                    let displayHeight = fBottom - fTop;
                    let movementHeight = photoHeight - displayHeight;

                    const newBgPosition = movementHeight > 0 ? `50% ${(0 - percentRange*movementHeight)}px` : 'center';
                    footerImageRef.current.style.backgroundPosition = newBgPosition;

                }

                // imageRef.current.style.transform = `translate(${-((20 * mouseX) / width)}px, ${-((40 * scrollIndex))}px)`;
            }


            // for the line through the timeline animation
            const timelineTop = timelineRef.current.getBoundingClientRect().top;
            const timelineBottom = timelineRef.current.getBoundingClientRect().bottom;
            // const lineTop = timelineLineRect.top;
            const lHeight = (timelineBottom) - (timelineTop - 55);

            const startLineDraw = timelineTop > window.innerHeight - 220;


            let lrange = (window.innerHeight) - (timelineTop);
            // console.log(lrange,lHeight);
            // let lrange = (window.innerHeight - (timelineTop+220)) + timelineBottom;
            let lPercentage = lrange/lHeight;

            if(lPercentage > 0){

            }

            if(lPercentage>=1){
                lPercentage=1;
            }

            setTimelineLineHeight(lPercentage*100);

            // for the timeline animation

            const timeline = timelineRef.current;
            const segments = timeline.querySelectorAll('.timeline-segment');

            // get the current scroll position
            const currentScrollPos = pageWrapper.pageYOffset || pageWrapper.scrollTop;

            let tindex = (lHeight - timelineTop - 80);

            if(tindex > 400){
                lineArrowRef.current.classList.add('show');
            }else{
                lineArrowRef.current.classList.remove('show');
            }

            segments.forEach((segment) => {
              const segmentTop = segment.offsetTop;
              const segmentHeight = segment.offsetHeight;
              const segmentBottom = segmentTop + segmentHeight;
              // console.log(segmentTop)

              if(segmentTop+300 < tindex){

                  segment.classList.add('animate-in');


              }else{
                  segment.classList.remove('animate-in');
              }
              // check if the segment is in view
              if (segmentTop <= currentScrollPos + window.innerHeight && segmentBottom >= currentScrollPos) {
                  // console.log(segmentTop,currentScrollPos)
                // animate the circle and line elements
                // use CSS animations with the animation property for smooth animations

                // animate the panel elements
                // use CSS animations with the animation-delay property for staggered animation
              }
            });

            // update the current scroll position
            scrollPos.current = currentScrollPos;




        };

        if(pageWrapper){
            slideIn();
            pageWrapper.addEventListener('scroll', slideIn);
        }



        if (pageWrapper) {

        }

        return () => {
          if (pageWrapper) {
            pageWrapper.removeEventListener('scroll', slideIn);
          }
        };


    }, [ p1Height, accessAllowed ]);


    const openApp = () => {
        window.open(
            `${process.env.REACT_APP_ARTEMIS_APP_URL}`,
            "_blank"
        )
    }


    const authHandler = (err, data) => {
        console.log(err, data);
    };

    

    const openPage = (type) => {
        let u = null;

        switch(type){
            case "chart":
                u = `${process.env.REACT_APP_ARTEMIS_APP_URL}/ethereum/0xfFBc8746159cd0b7cD4ad70Bcb5662c1072682F5?view=chart`;
                break;
            case "uniswap":
                u = `https://app.uniswap.org/#/swap?outputCurrency=${tokenAddress}&inputCurrency=eth`;
                break;
            case "buy0xdex":
                u = `${process.env.REACT_APP_ARTEMIS_APP_URL}/ethereum/0xfFBc8746159cd0b7cD4ad70Bcb5662c1072682F5`;
                break;

            case "metamask":
                u = `https://metamask.io`;
                break;


                
            case "howtobuy":
                u=`https://www.youtube.com/watch?v=RPDG4NlIVF8`;
                break;
            default:
                break;
        }
        if(u){
            window.open(
                u,
                "_blank"
            )
        }
        
    }

    const scrollToAnchor = (event) => {
        event.preventDefault(); // Prevent default anchor behavior
        const targetId = event.target.getAttribute('href').substring(1); // Get the ID (without '#')
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' }); // Smooth scrolling
        }
    };

    const memePhotosMemo = useMemo(() => {
        return memes.map((m, i) => {
            // Generate random rotation between -20 and 20 degrees
            const rotation = Math.floor(Math.random() * 61) - 30;
            
            // Generate random z-index (between 1 and 3 for three images)
            const zIndex = Math.floor(Math.random() * 4) + 1;
            
            // Generate random margin for overlapping effect
            const marginLeft = -Math.floor(Math.random() * 90) + 20;

            const marginTop = -Math.floor(Math.random() * 60) + 20;

            return (
                <div
                    key={i}
                    className="meme-photo"
                    style={{
                        transform: `rotate(${rotation}deg)`,
                        zIndex: zIndex,
                        marginLeft: `${marginLeft}px`,
                        marginTop: `${marginTop}px`,
                        position: 'relative',
                    }}
                >
                    <img src={require(`../../media/memes/${m}`)} alt="Meme" />
                </div>
            );
        });
    }, [memes]);


    return (
        <Layout>
            <Helmet><title>Welcome to 0xdex</title>
            </Helmet>

{/*
            <TickerBlock/>
*/}

            {/*<div className="hero-text">
                <p><span className="mute">: :</span> <span style={{fontFamily:'Roboto Mono, monospace'}}>0xDex</span> is a media-centric Defi investment workflow <span className="mute">+</span> portfolio manager.</p>
            </div>*/}

            {/*<a href="https://ethereum.org" target="_blank"  data-tip={'ethereum.org'} className="ethereum-logo transition">
                <img src={require(`../../media/photos/ethereum_logo.png`)}/>
            </a>
*/}

            <div className="typewriter-wrapper">
                <img style={{marginLeft:3, width:55,height:55,marginTop:-27}} src={require(`../../media/logo_dexter_bot.png`)}/>
                <div className="flex-row">
                    <div style={{marginTop:5,marginRight:3}} className="icon-chevron-right">


                    </div>

                    <Typewriter
                        key={tkey}
                        options={{
                        loop: true,
                        delay: 99,
                        deleteSpeed: 33,
                        }}
                    onInit={(typewriter) => {
                        typewriter.pauseFor(1700)
                        .typeString("0xdex is live! ⚡")
                        .pauseFor(2700)
                        .deleteAll('natural')
                        .pauseFor(1100)
                        .typeString('Welcome.')
                        .pauseFor(2700)
                        .deleteChars(1)
                        .typeString(', to 0xdex')
                        .pauseFor(333)
                        .typeString('. 🚀')
                      
                        .pauseFor(3300)
                        .deleteAll('natural')
                        .typeString(btcPrice > 0 ? `current prices` : "")
                        .pauseFor(btcPrice > 0 ? 2400 : 0)
                        .deleteAll()
                        .pauseFor(ethPrice > 0 ? 900 : 0)
                        .typeString(ethPrice > 0 ? `BTC $${addCommas(Math.round(btcPrice))} <div style={{opacity:.55}}>:</div> ETH $${addCommas(Math.round(ethPrice))} <div style={{opacity:.55}}>:</div> SOL $${addCommas(Math.round(solPrice))}` : "")
                        .pauseFor(ethPrice > 0 ? 4400 : 0)
                        .deleteAll()
                        .pauseFor(ethPrice > 0 ? 900 : 200)
                        .typeString('0xdex')
                        .pauseFor(2200)
                        .typeString(' is')
                        .pauseFor(2200)
                        .typeString(' efficiency. ')
                        .pauseFor(400)
                        .typeString('📁')
                        .pauseFor(1900)
                        .deleteChars(14)
                        .pauseFor(1800)
                        .typeString('curation.')
                        .pauseFor(2200)
                        .deleteChars(9)
                        .pauseFor(1500)

                        .pauseFor(1300)
                        .typeString('portability.')
                        
                        .pauseFor(1500)
                        .deleteChars(12)
                        .pauseFor(900)
                        .typeString('innovation. 🌱')
                        .pauseFor(3500)
                        .deleteChars(17)
                        .pauseFor(2200)
                        .typeString('simplifies Decentralized Finance (DeFi).')
                        .pauseFor(3700)
                        .deleteAll()
                        //   .typeString("If you're still here, welcome to crypto.")
                        //   .pauseFor(3700)
                        //   .deleteAll()
                        .callFunction(() => {
                            setTKey(prevKey => prevKey + 1);
                        })
                        .callFunction(() => {
                            console.log('All strings were deleted');
                        })
                        .start();
                    }}
                    />
                </div>
            </div>
            
            


            <div className="hero-image-container">

                <div className="hero-hue">
                    <div className="hero-logo">
                        <img style={{maxWidth:244}} src={logo0x} alt="0xdex logo" />
                        {/* <p style={{margin:0,paddingLeft:25, fontSize:16, color: '#97d9f4'}}>Ze·​ro·X·Dex</p>
                        <h5 style={{paddingLeft:25}}>A first<span style={{fontSize:16, color: '#97d9f4',fontWeight:100}}>-</span>of<span style={{fontSize:16, color: '#97d9f4',fontWeight:100}}>-</span>its<span style={{fontSize:16, color: '#97d9f4',fontWeight:100}}>-</span>kind Decentralized Finance (DeFi) explorer <span style={{fontSize:16, color: '#97d9f4',fontWeight:100}}>+</span> collobaration platform.</h5> */}
                        <div className="flex-row">
                            <button className="outline" onClick={openApp} style={{marginLeft:25}}>
                                Open App    
                            </button>
                            {/* <div onClick={() => openPage("chart")} style={{marginLeft:11}} className="button outline">
                                View Chart
                            </div>
                            <div onClick={() => openPage("buy0xdex")} style={{marginLeft:11}} className="button outline">
                                Buy
                            </div> */}
                            <a onClick={scrollToAnchor} style={{marginLeft: 7,maxWidth:120}} className="button outline" href="#howtobuy">How to Buy</a>
                        </div>
                        
                        {/* <div style={{marginLeft:22,marginTop:44}} className="flex-row">
                            <img data-tip={`metamask`} style={{marginLeft:3,marginTop:3,filter:"grayscale(1)",transform:'scale(1.33)'}} className="chain-icon" src={require(`../../icons/logo_metamask.png`)}/>
                        </div> */}
                        <div style={{marginLeft:22,marginTop:44}} className="flex-row">
                            <div style={{margin:7,opacity:.5,marginRight:17}} className="icon-button-link"></div>
                       
                            <img className="chain-icon large" src={require(`../../icons/logo_chain_ethereum.png`)}/>
                            <img style={{marginLeft:3}} className="chain-icon large" src={require(`../../icons/logo_chain_base.png`)}/>
                            <img style={{marginLeft:7}} className="chain-icon large" src={require(`../../icons/logo_chain_solana.png`)}/>
                            <img style={{marginLeft:7}} className="chain-icon large" src={require(`../../icons/logo_chain_tron.png`)}/>
                            <img style={{marginLeft:7}} className="chain-icon large" src={require(`../../icons/logo_chain_ton.png`)}/>
                            <img style={{marginLeft:7}} className="chain-icon large" src={require(`../../icons/logo_chain_sui.png`)}/>
                           
                            
                        </div>

                        <div style={{margin:22}} className="flex-row">
                            <div style={{transform:"scale(.6)",opacity:.5,marginLeft:3,marginRight:17}} className="svg-icon">
                                <WalletIcon/>
                            </div>
                            <img data-tip={`metamask`} style={{marginRight:11,marginTop:0,transform:'scale(1)'}} className="chain-icon wallet-icon" src={require(`../../icons/logo_metamask.png`)}/>
                            {tgSnipersLogos.map((k, i) => {
                                    
                                    return (

                                        
                                        <img key={i} style={{marginRight:11}} className="chain-icon wallet-icon" src={require(`../../icons/swaps/logo_${k}.png`)}/>
                                              

                                    )
                                
                            })}
                        </div>

                    </div>
                    {/*<div className="hero-hue-blue"/>
                    <div className="hero-hue-dark-corner"/>*/}
                </div>

                {/*<div className="dot-overlay"></div>*/}

                <GridCanvas mouseX={mouseX} mouseY={mouseY} width={windowDimensions.width+100} height={windowDimensions.height+100}/>

                {/* { heroImage && (
                    <div className="hero-image" style={{backgroundImage:`url(${require(`../../media/photos/${heroImage}`)})`}} ref={imageRef}/>
                )} */}

                <div className="hero-scroll-arrow"
                    onClick={() => {
                        const pWrapper = document.querySelector('.page-wrapper');
                        pWrapper.scrollTo({
                            top: window.innerHeight - 44,
                            behavior: 'smooth',
                        });
                    }}
                >
                    <div className="icon-button-chevron-down"/>
                </div>
            </div>

            <div style={{paddingBottom:0}} className="text-panel dark">
                <div ref={animateRefs[0]} className="animate-container transition-long">
                    <div className="slide-in-text">
                        {/* <div className="flex-row"> */}
                            {/* <h4>About</h4> */}
                            <p style={{fontSize: 21, lineHeight: '27px', flex:4}}>0xdex is a <span style={{fontWeight:600}}>collaborative dashboard</span> for signals, news, analyzing and transacting in <span style={{fontWeight:600}}>Decentralized Finance (DeFi)</span>. Through innovative design, features and integrations, we bring massive portability and efficiencies to the space and process. Finding and managing Altcoin and Meme Token Portfolios has never been easier.</p>

                        {/* </div> */}

                    </div>

                </div>
            </div>

            <div style={{paddingBottom:55}} className="text-panel light app-features">

                {/*<p>To <span style={{fontWeight:600}}>simplify the complexity of Decentralized Finance (Defi)</span>, through innovative design, integrations and streamlining of the trading process.</p>*/}
                {/*<div ref={animateRefs[0]} className="animate-container image-left transition-long">
                    <div className="slide-in-image">
                        <img src={require(`../../media/photos/website/ticker.jpg`)} />
                    </div>

                </div>*/}

                <div ref={animateRefs[1]} className="animate-container slide-right image-right transition-long">
                    <div className="slide-in-text">
                        <div className="flex-row align center">
                            <div className="icon icon-button-eye"></div>
                            <h2 className="bold">Vision</h2>
                        </div>

                        <p>The 0xDex dashboard is focused on efficiency and minimalism. It is a highly coupled platform in multiple dimensions, from news, to calls, to real-time trending data and lightning fast transactions with the smartest wallets/bots available. 
                            
                        <br/><br/>
                        </p>
                        {/* <h3>We introduce a <span style={{fontWeight:600}}>first-of-its-kind<br/>smart dashboard</span>.</h3> */}
                    </div>
                    <div className="slide-in-image" >
                        <img src={require(`../../media/photos/website/pepe_list.jpg`)} />
                    </div>
                </div>

                <div ref={animateRefs[2]} className="animate-container slide-right image-right transition-long">
                    <div style={{display:'flex',justifyContent:'center'}} className="slide-in-image" >
                        <img src={require(`../../media/photos/website/peanut_trending.jpg`)} />
                    </div>
                </div>

                <div ref={animateRefs[3]} className="animate-container slide-left image-left transition-long">
                    <div className="slide-in-image wide">
                        <img src={require(`../../media/photos/website/shibtx.jpg`)} />
                    </div>
                    <div className="slide-in-text">

                        <div className="flex-row align center">
                            <div className="svg-icon">
                                <svg width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.7993 12A1.7994 1.7994 0 0 1 12 13.7994 1.7994 1.7994 0 0 1 10.2006 12 1.7994 1.7994 0 0 1 12 10.2006 1.7994 1.7994 0 0 1 13.7993 12m1.4731 3.2622a35.2223 35.2223 0 0 1-3.3126 2.9618 44.0775 44.0775 0 0 1-3.3126-2.9618 35.2127 35.2127 0 0 1-2.9611-3.3126A35.2127 35.2127 0 0 1 8.6472 8.637a43.9342 43.9342 0 0 1 3.3126-2.9611 43.9342 43.9342 0 0 1 3.3126 2.9611 35.1287 35.1287 0 0 1 2.9611 3.3126 29.2652 29.2652 0 0 1-2.961 3.3126m1.004-7.5806a40.9184 40.9184 0 0 0-3.1621-2.861c2.9611-2.1592 5.722-3.4632 7.6292-3.4632a1.8893 1.8893 0 0 1 1.4053.4523c1.1042 1.1042.2507 4.2662-2.359 8.0803h1.656a25.0968 25.0968 0 0 0 1.4054-2.4592c1.4053-3.0115 1.506-5.32.2999-6.5748a3.6587 3.6587 0 0 0-2.458-.8517c-3.2124 0-8.3333 3.0115-12.9997 7.6773a40.9184 40.9184 0 0 0-2.861 3.162C1.721 6.5792.6672 2.9655 1.8212 1.8115a1.9685 1.9685 0 0 1 1.4053-.4523c1.707 0 4.1157 1.0545 6.6755 2.8112V2.5642C7.3924.9076 5.0335.0043 3.2264.0043a3.2292 3.2292 0 0 0-2.359.8535c-1.2547 1.2548-1.103 3.5633.3017 6.5748 1.3045 2.8106 3.6635 5.9223 6.5244 8.8337a40.9184 40.9184 0 0 0 3.1621 2.861c-2.9108 2.1592-5.722 3.463-7.6293 3.463a1.8917 1.8917 0 0 1-1.4052-.454c-1.1042-1.1042-.2508-4.2662 2.359-8.0808H2.5743a25.167 25.167 0 0 0-1.4053 2.459c-1.4047 3.014-1.506 5.322-.3017 6.5779a3.2316 3.2316 0 0 0 2.359.8529c3.2124 0 8.3321-3.0115 12.9997-7.6772a40.808 40.808 0 0 0 2.861-3.1621c3.1092 4.2645 4.166 7.8782 3.0114 9.0303a1.8905 1.8905 0 0 1-1.4052.4517c-1.7064 0-4.1158-1.0538-6.6756-2.8106v1.656c2.5598 1.6086 4.9188 2.5623 6.6756 2.5623a3.2292 3.2292 0 0 0 2.3589-.8535c1.2548-1.2548 1.1042-3.5633-.2999-6.5748-1.256-2.861-3.6149-5.9727-6.4759-8.8858Z"/>
                                </svg>
                            </div>
                            <h2 className="bold">Fusion</h2>
                        </div>
                        <p>0xdex currently supports six blockchains.</p>
                        <div style={{marginTop:11,marginBottom:11}} className="flex-row">
                            <div style={{margin:7,opacity:.5,marginRight:17}} className="icon-button-link"></div>
                       
                            <img className="chain-icon large" src={require(`../../icons/logo_chain_ethereum.png`)}/>
                            <img style={{marginLeft:3}} className="chain-icon large" src={require(`../../icons/logo_chain_base.png`)}/>
                            <img style={{marginLeft:7}} className="chain-icon large" src={require(`../../icons/logo_chain_solana.png`)}/>
                            <img style={{marginLeft:7}} className="chain-icon large" src={require(`../../icons/logo_chain_tron.png`)}/>
                            <img style={{marginLeft:7}} className="chain-icon large" src={require(`../../icons/logo_chain_ton.png`)}/>
                            <img style={{marginLeft:7}} className="chain-icon large" src={require(`../../icons/logo_chain_sui.png`)}/>
                           
                            
                        </div>
                        
                        <p>The dashboard integrates real-time trending data from 28 different chain/channel sources, along with news and calls into a smart dashboard. Real-time notifications are received with custom sound effects. And with smart wallet integrations for swapping, it's an entirely new experience.
                        <br/><br/>

                        </p>
                    </div>
                </div>

                <div ref={animateRefs[4]} className="animate-container slide-right image-right transition-long">
                    <div className="slide-in-text">
                        <div className="flex-row align center">
                            <div className="icon icon-button-layers"></div>
                            <h2 className="bold">Portability</h2>
                        </div>
                        <p>Real-time lists are easy with a comprehensive suite, including seamless integration with X Spaces and YouTube live events. Configurations are available with public/private capability, as well as the ability to follow others and publish. API access will follow close behind.
                        <br/><br/>
                        </p>
                    </div>
                    <div className="slide-in-image wide">
                        <img src={require(`../../media/photos/website/xspace.jpg`)} />
                    </div>
                </div>

                <div ref={animateRefs[5]} className="animate-container slide-right transition-long">
                    {/* <div className="slide-in-image">
                        <img src={require(`../../media/photos/website/trending_elon.jpg`)} />
                    </div> */}
                    {/* <div className="slide-in-image">
                        <img src={require(`../../media/photos/website/user_profile.jpg`)} />
                    </div> */}
                    <div className="slide-in-image">
                        <img src={require(`../../media/photos/website/dashboard_chart.jpg`)} />
                    </div>
                    {/* <div className="slide-in-image">
                        <img src={require(`../../media/photos/website/peanut_trending.jpg`)} />
                    </div> */}
                    {/* <div className="slide-in-image">
                        <img src={require(`../../media/photos/website/twitter_post.jpg`)} />
                    </div> */}
                </div>

                <div ref={animateRefs[6]} className="animate-container slide-right transition-long">
                    <div className="slide-in-image">
                        <img src={require(`../../media/photos/website/strategic.jpg`)} />
                    </div>
                    <div className="slide-in-image">
                        <img src={require(`../../media/photos/website/news_notifications.jpg`)} />
                    </div>
                    {/* <div className="slide-in-image">
                        <img src={require(`../../media/photos/website/peanut_trending.jpg`)} />
                    </div> */}
                    {/* <div className="slide-in-image">
                        <img src={require(`../../media/photos/website/twitter_post.jpg`)} />
                    </div> */}
                </div>
                <div ref={animateRefs[7]} className="animate-container slide-left image-left transition-long">
                    <div className="slide-in-image wide">
                        <img src={require(`../../media/photos/website/social_lists.jpg`)} />
                    </div>
                    <div className="slide-in-text">
                        <div className="flex-row align center">
                            <div className="icon icon-button-users"></div>
                            <h2 className="bold">Collaboration</h2>
                        </div>
                        <p>0xdex provides massive portability, allowing follows of other users and lists, with shareable links and QR codes throughout. Quickly build, find and share meta in real-time.
                        <br/><br/> 

                        </p>
                    </div>

                    

                </div>

                <h3>This is just the beginning.</h3>


                




                {/*<div ref={animateRefs[6]} className="animate-container slide-right image-right transition-long">

                    <div className="slide-in-text">
                        <div className="flex-row align center">
                            <div className="svg-icon">
                                <NeuralIcon/>
                            </div>
                            <h2 className="bold">Future</h2>
                        </div>
                        <p>Our sound foundation, and rich parameter context is prime for the future development of our neural network. We look to further explore the real potential of coupling sentiment and market metrics, and continue to actively develop features and integrations.
                        <br/><br/>
                        </p>
                    </div>
                    <div className="slide-in-image wide">
                        <img src={require(`../../media/photos/website/sentiment.jpg`)} />
                    </div>
                </div>*/}






            </div>

            <div style={{paddingBottom:0,paddingTop:22}} className="text-panel dark">
                <div ref={animateRefs[8]} style={{flexDirection:"column",alignItems:'center'}} className="animate-container transition-long">
                    
                    <div className="flex-row">
                        <h5 style={{margin:'0 37px'}}>Access</h5>
                        <p style={{fontSize:14,maxWidth:320}}>We provide some of the platform for free. Real dashboard access is available by holding a minimum amount of tokens in your wallet.</p>
                    
                    </div>
                    
                    
                    <div style={{justifyContent:'center'}} className="flex-row full">
                        <FeatureTable features={dashboardFeatures}/>
                    </div>
                    
                    <div style={{marginTop:33}} className="flex-row">
                        <h5 onClick={() => openPage("metamask") } className="data-panel interactive" style={{alignItems:"center",maxWidth:55,maxHeight:55,margin:'0 37px'}}>
                            <img style={{width:33,height:33}} src={require(`../../icons/logo_metamask.png`)}/>

                        </h5>
                        <p style={{fontSize:14,maxWidth:270}}>For <span style={{fontWeight:'600'}}>Degen</span>, <span style={{fontWeight:'600'}}>Degen Pro</span> and <span style={{fontWeight:'600'}}>GigaChad Pro<span className="green">+</span></span>, buy and hold <span style={{fontWeight:'600'}}>0xdex</span> tokens in your wallet on Ethereum chain.<br/><br/>Use wallet to authenticate by 'connecting wallet' to access features within the app.</p>
                    </div>

                    <div style={{marginTop:11}} className="flex-row">
                        
                        <div onClick={() => openPage("chart")} style={{margin:11}} className="flex-row align center data-panel interactive">
                            View Chart
                            {/* <div style={{width: 22,height: 22,opacity: .5,marginLeft: 8}} className="dex-icon">
                                <img style={{maxWidth:'100%',maxHeight:'100%'}} src={require(`../../icons/data/logo_dexscreener_mark.png`)}/>
                            </div> */}
                        </div>

                        

                        <div onClick={() => openPage("buy0xdex")} style={{margin:11}} className="flex-row align center data-panel interactive">
                            Buy on 0xdex
                        
                        </div>

                        <div onClick={openApp} style={{margin:11}} className="flex-row align center data-panel interactive">
                            Open App
                        
                        </div>

                    </div>

                        
                    
                </div>
            </div>

            {/* <div style={{paddingTop:0}} className="text-panel light">


                <div style={{paddingTop:0,paddingBottom:88}} ref={animateRefs[7]} className="animate-container transition-long">
                    <div className="slide-in-text">
                        <div className="flex-row">
                            <h4>Status</h4>
                            <p style={{flex:4}}>The <span style={{fontWeight:600}}>0xDex Decentralized application (dApp)</span> has been in development for more than 6 months.
                            <br/><br/>We will begin testing with a user group late July 2023, with a <span style={{fontWeight:600}}>projected public launch beginning of Q4 2023</span>.</p>

                        </div>

                    </div>

                </div>


            </div> */}


            <div ref={animateRefs[9]} className="dark-panel animate-children">
                <h5 style={{marginBottom:22,marginTop:22}}>Data providers</h5>
                <div className="provider-logos animate-children">
                { dataProviderLogos.map((p, i) => (
                    <a key={i} href={p.href} data-tip={`${p.desc}`} target="_blank" className="provider-logo transition" style={{padding: p.circular ? '18px' : 'initial' }}>
                        <img src={require(`../../icons/data/${p.url}`)}/>
                    </a>
                ))}
                </div>
            </div>



            <div ref={animateRefs[10]} style={{minHeight:333,justifyContent:'center',alignItems:'center'}} className="content-panel animate-children border-cap">

                { heroImage && (
                    <div ref={parallaxRefs[0]}
                    style={{
                        backgroundImage:`url(${require(`../../media/photos/${heroImage}`)})`,
                        backgroundSize: 'cover',
                        transitionDelay:'0 !important'
                        // filter: 'saturate(0) contrast(1.3)'
                    }}
                    className="parallax-image animate-off"/>

                )}
                <div style={{height:"100%",zIndex:-1,top:0,borderTop:'2px solid #171717'}} className="ticker-overlay animate-off"></div>

                <h2>Roadmap</h2>



            </div>


            <div className="timeline" ref={timelineRef}>
                <div className="line" style={{ height: `${timelineLineHeight}%`,maxHeight: `calc( ${timelineLineHeight}% - 110px )` }} ref={timelineLineRef}>
                    <div ref={lineArrowRef} className="arrow">
                        &#9660;
                    </div>
                </div>
                <div className="timeline-segment panel-right">
                    <div style={{background:'#19ac57'}} className="circle"></div>
                    <div className="panel">
                        <h4>Q1 2025</h4>
                        <ul>
                            <li>Community growth + engagement</li>
                            <li>Live list spaces on X + YouTube</li>
                            <li>Mobile optimization</li>
                            <li>Activity Feed</li>
                            <li>News + Signals channel</li>
                            <li>Token/access partnerships + promotions</li>
                            
                            <li>Telegram Bot v2</li>
                            <li>Expand team</li>
                            <li>Further data integrations</li>
                        </ul>
                    </div>
                </div>
                <div className="timeline-segment panel-left">
                    <div className="circle"></div>
                    <div className="panel">
                        <h4>Q2 2025</h4>
                        <ul>
                            <li>Private + Public Chat Rooms</li>
                            <li>MoonPay Integration</li>
                            <li>AI Assistant</li>
                            
                            <li>API access</li>
                            <li>Education + onboarding curriculum</li>
                            <li>Furthered community engagement</li>
                            <li>Continuous development</li>
                            <li>Features + Integrations strategy</li>
                            
                        </ul>
                    </div>
                </div>
                <div className="timeline-segment panel-right">
                    <div className="circle"></div>
                    <div className="panel">
                        <h4>Q3 2025 +</h4>
                        <ul>
                            <li>Expand data/features</li>
                            <li>Data visualization</li>
                            <li>Partnership strategies/development</li>
                        </ul>
                    </div>
                </div>

                <div style={{ transform: timelineLineHeight > 80 ? `translateY(-${timelineLineHeight/2.8}px)` : 'translateY(0)'}} className="moon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                        <path d="M17.39 15.14A7.33 7.33 0 0 1 11.75 1.6c.23-.11.56-.23.79-.34a8.19 8.19 0 0 0-5.41.45 9 9 0 1 0 7 16.58 8.42 8.42 0 0 0 4.29-3.84 5.3 5.3 0 0 1-1.03.69z"/>
                    </svg>
                </div>
                {/*<div className="timeline-segment panel-left">
                    <div className="circle"></div>
                    <div className="panel">
                        <h4>phase 4</h4>
                    </div>
                </div>*/}

            </div>



            <div id="howtobuy" style={{paddingBottom:55,paddingTop:33}} className="text-panel">

                <div style={{marginBottom:22}} className="flex-row wrap">
                    {memePhotosMemo}
                </div>

                {/* <div ref={animateRefs[11]} className="animate-container transition-long">
                    <div className="slide-in-text">
                        <div className="flex-row">
                            <h4 style={{paddingRight:22}}>Tokenomics</h4>
                            <p style={{flex:4,color:'white'}}>Access to the platform is available by holding a certain amount of 0xdex tokens (ERC-20), or an amount of our partner tokens.<br/><br/>
                            <span style={{color:'white'}}>The 0xDex ERC-20 token is now live and available to swap through <a href="https://uniswap.org" target="_blank" style={{fontWeight:'600'}}>Uniswap</a> on the <a target="_blank" href="https://ethereum.org" style={{fontWeight:'600'}}>Ethereum</a> chain</span>.
                            </p>

                        </div>

                    </div>
                </div> */}

               
                
                <div style={{marginTop:3}} className="flex-row align center">
                    <div style={{fontSize:22,marginTop:3,marginRight:11,color: "green"}} className="icon-check"/>
                    <div style={{marginRight:11,width:33,height:33}} className="svg-icon">
                        <CoinIcon/>
                    </div>
                    <h2 style={{margin:0}}>ERC-20 Token</h2>
                    <div style={{transform: 'scale(.44)', opacity:.77, maxWidth:122}} className="content-panel-element">

                        <img style={{maxWidth:'100%'}} src={require(`../../media/photos/ethereum_logo.png`)}/>

                    </div>

                </div>


                <div style={{justifyContent:'center',marginTop:0}} className="content-row">

                    <div className="content-panel-element">
                        {/*<img src={require(`../../media/dexter_content_tyrant_data.png`)}/>*/}
                        <h1><span style={{fontFamily: "Roboto Mono"}}>0</span>XDEX</h1>
                        <p>Symbol</p>
                    </div>

                    <div className="content-panel-element">
                        {/*<img src={require(`../../media/dexter_content_dogen.png`)}/>*/}
                        <h1><span style={{fontFamily: "Roboto Mono"}}>0</span>xDex</h1>
                        <p>Name</p>
                    </div>

                    <div className="content-panel-element">
                        <div className="uni-logo">
                            <UniswapIcon/>

                        </div>

                        <p>Swap</p>
                    </div>

                </div>

                {/*<h4>features</h4>
                */}
                <div style={{justifyContent:'center',marginTop:22}} className="content-row">

                    <div className="content-panel-element">
                        {/*<img src={require(`../../media/dexter_content_tyrant_data.png`)}/>*/}
                        <h1>1 Billion</h1>
                        <p>Token Supply</p>
                    </div>


                    <div className="content-panel-element">
                       
                        <h1>5<span className="small mute">%</span> &nbsp;<span style={{opacity:.2,fontWeight:'100'}} className="small mute">|</span>&nbsp; 5<span className="small mute">%</span></h1>
                        <p>Buy <span style={{fontWeight:'100'}} className="mute">|</span> Sell Tax</p>
                    </div>

                    <div className="content-panel-element">
                       
                        <h1>2<span className="small mute">%</span></h1>
                        <p>Max Wallet <span style={{fontWeight:'100'}} className="mute">|</span> Tx</p>
                    </div>

                </div>


                <div style={{marginTop:22,marginBottom:55}} className="flex-column align center">

                    <ContractAddressToolbar
                        addStyle={{marginTop:44}}
                        title="Contract Address"
                        label="0xDex"
                        layout="full"
                        type="token"
                        ca={`${tokenAddress}`}/>

                    {/*<ContractAddressToolbar
                        addStyle={{marginTop:22}}
                        title="pair address"
                        label="pair"
                        type="address"
                        ca={`${pairAddress}`}/>*/}

                </div>

                <div className="flex-row">

                    <div onClick={() => openPage("chart")} style={{margin:11}} className="flex-row align center data-panel interactive">
                        View Chart
                        {/* <div style={{width: 22,height: 22,opacity: .5,marginLeft: 8}} className="dex-icon">
                            <img style={{maxWidth:'100%',maxHeight:'100%'}} src={require(`../../icons/data/logo_dexscreener_mark.png`)}/>
                        </div> */}
                    </div>

                    

                    <div onClick={() => openPage("buy0xdex")} style={{margin:11}} className="flex-row align center data-panel interactive">
                        Buy on 0xdex
                      
                    </div>

                    {/* <div onClick={() => openPage("uniswap")} style={{margin:11}} className="flex-row align center data-panel interactive">
                        Buy on Uniswap
                        <div style={{marginLeft:11}} className="svg-icon swap-small" currentitem="false"><svg width="600" height="600" viewBox="80 80 500 500" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M224.534 123.226C218.692 122.32 218.445 122.213 221.195 121.791C226.464 120.98 238.905 122.085 247.479 124.123C267.494 128.881 285.707 141.069 305.148 162.714L310.313 168.465L317.701 167.277C348.828 162.275 380.493 166.25 406.978 178.485C414.264 181.851 425.752 188.552 427.187 190.274C427.645 190.822 428.485 194.355 429.053 198.124C431.02 211.164 430.036 221.16 426.047 228.625C423.877 232.688 423.756 233.975 425.215 237.452C426.38 240.227 429.627 242.28 432.843 242.276C439.425 242.267 446.509 231.627 449.791 216.823L451.095 210.943L453.678 213.868C467.846 229.92 478.974 251.811 480.885 267.393L481.383 271.455L479.002 267.762C474.903 261.407 470.785 257.08 465.512 253.591C456.006 247.301 445.955 245.161 419.337 243.758C395.296 242.491 381.69 240.438 368.198 236.038C345.244 228.554 333.672 218.587 306.405 182.812C294.294 166.923 286.808 158.131 279.362 151.051C262.442 134.964 245.816 126.527 224.534 123.226Z" fill="#B3B3B3"></path><path d="M432.61 158.704C433.215 148.057 434.659 141.033 437.562 134.62C438.711 132.081 439.788 130.003 439.954 130.003C440.12 130.003 439.621 131.877 438.844 134.167C436.733 140.392 436.387 148.905 437.84 158.811C439.686 171.379 440.735 173.192 454.019 186.769C460.25 193.137 467.497 201.168 470.124 204.616L474.901 210.886L470.124 206.405C464.282 200.926 450.847 190.24 447.879 188.712C445.89 187.688 445.594 187.705 444.366 188.927C443.235 190.053 442.997 191.744 442.84 199.741C442.596 212.204 440.897 220.204 436.797 228.203C434.58 232.529 434.23 231.606 436.237 226.723C437.735 223.077 437.887 221.474 437.876 209.408C437.853 185.167 434.975 179.339 418.097 169.355C413.821 166.826 406.776 163.178 402.442 161.249C398.107 159.32 394.664 157.639 394.789 157.514C395.267 157.038 411.727 161.842 418.352 164.39C428.206 168.181 429.833 168.672 431.03 168.215C431.832 167.909 432.22 165.572 432.61 158.704Z" fill="#B3B3B3"></path><path d="M235.883 200.175C224.022 183.846 216.684 158.809 218.272 140.093L218.764 134.301L221.463 134.794C226.534 135.719 235.275 138.973 239.369 141.459C250.602 148.281 255.465 157.263 260.413 180.328C261.862 187.083 263.763 194.728 264.638 197.317C266.047 201.483 271.369 211.214 275.696 217.534C278.813 222.085 276.743 224.242 269.853 223.62C259.331 222.67 245.078 212.834 235.883 200.175Z" fill="#B3B3B3"></path><path d="M418.223 321.707C362.793 299.389 343.271 280.017 343.271 247.331C343.271 242.521 343.437 238.585 343.638 238.585C343.84 238.585 345.985 240.173 348.404 242.113C359.644 251.128 372.231 254.979 407.076 260.062C427.58 263.054 439.119 265.47 449.763 269C483.595 280.22 504.527 302.99 509.518 334.004C510.969 343.016 510.118 359.915 507.766 368.822C505.91 375.857 500.245 388.537 498.742 389.023C498.325 389.158 497.917 387.562 497.81 385.389C497.24 373.744 491.355 362.406 481.472 353.913C470.235 344.257 455.137 336.569 418.223 321.707Z" fill="#B3B3B3"></path><path d="M379.31 330.978C378.615 326.846 377.411 321.568 376.633 319.25L375.219 315.036L377.846 317.985C381.481 322.065 384.354 327.287 386.789 334.241C388.647 339.549 388.856 341.127 388.842 349.753C388.828 358.221 388.596 359.996 386.88 364.773C384.174 372.307 380.816 377.649 375.181 383.383C365.056 393.688 352.038 399.393 333.253 401.76C329.987 402.171 320.47 402.864 312.103 403.299C291.016 404.395 277.138 406.661 264.668 411.04C262.875 411.67 261.274 412.052 261.112 411.89C260.607 411.388 269.098 406.326 276.111 402.948C285.999 398.185 295.842 395.586 317.897 391.913C328.792 390.098 340.043 387.897 342.9 387.021C369.88 378.749 383.748 357.402 379.31 330.978Z" fill="#B3B3B3"></path><path d="M404.719 376.105C397.355 360.273 395.664 344.988 399.698 330.732C400.13 329.209 400.824 327.962 401.242 327.962C401.659 327.962 403.397 328.902 405.103 330.05C408.497 332.335 415.303 336.182 433.437 346.069C456.065 358.406 468.966 367.959 477.74 378.873C485.423 388.432 490.178 399.318 492.467 412.593C493.762 420.113 493.003 438.206 491.074 445.778C484.99 469.653 470.85 488.406 450.682 499.349C447.727 500.952 445.075 502.269 444.788 502.275C444.501 502.28 445.577 499.543 447.18 496.191C453.965 482.009 454.737 468.214 449.608 452.859C446.467 443.457 440.064 431.985 427.135 412.596C412.103 390.054 408.417 384.054 404.719 376.105Z" fill="#B3B3B3"></path><path d="M196.519 461.525C217.089 444.157 242.682 431.819 265.996 428.032C276.043 426.399 292.78 427.047 302.084 429.428C316.998 433.245 330.338 441.793 337.276 451.978C344.057 461.932 346.966 470.606 349.995 489.906C351.189 497.519 352.489 505.164 352.882 506.895C355.156 516.897 359.583 524.892 365.067 528.907C373.779 535.283 388.78 535.68 403.536 529.924C406.041 528.947 408.215 528.271 408.368 528.424C408.903 528.955 401.473 533.93 396.23 536.548C389.177 540.071 383.568 541.434 376.115 541.434C362.6 541.434 351.379 534.558 342.016 520.539C340.174 517.78 336.032 509.516 332.813 502.176C322.928 479.628 318.046 472.759 306.568 465.242C296.579 458.701 283.697 457.53 274.006 462.282C261.276 468.523 257.724 484.791 266.842 495.101C270.465 499.198 277.223 502.732 282.749 503.419C293.086 504.705 301.97 496.841 301.97 486.404C301.97 479.627 299.365 475.76 292.808 472.801C283.852 468.76 274.226 473.483 274.272 481.897C274.292 485.484 275.854 487.737 279.45 489.364C281.757 490.408 281.811 490.491 279.929 490.1C271.712 488.396 269.787 478.49 276.394 471.913C284.326 464.018 300.729 467.502 306.362 478.279C308.728 482.805 309.003 491.82 306.94 497.264C302.322 509.448 288.859 515.855 275.201 512.368C265.903 509.994 262.117 507.424 250.906 495.876C231.425 475.809 223.862 471.92 195.777 467.536L190.395 466.696L196.519 461.525Z" fill="#B3B3B3"></path><path fillRule="evenodd" clipRule="evenodd" d="M49.6202 12.0031C114.678 90.9638 214.977 213.901 219.957 220.784C224.068 226.467 222.521 231.576 215.478 235.58C211.561 237.807 203.508 240.063 199.476 240.063C194.916 240.063 189.779 237.867 186.038 234.318C183.393 231.81 172.721 215.874 148.084 177.646C129.233 148.396 113.457 124.131 113.027 123.725C112.032 122.785 112.049 122.817 146.162 183.854C167.582 222.181 174.813 235.731 174.813 237.543C174.813 241.229 173.808 243.166 169.261 248.238C161.681 256.694 158.293 266.195 155.847 285.859C153.104 307.902 145.394 323.473 124.026 350.122C111.518 365.722 109.471 368.581 106.315 374.869C102.339 382.786 101.246 387.221 100.803 397.219C100.335 407.79 101.247 414.619 104.477 424.726C107.304 433.575 110.255 439.417 117.8 451.104C124.311 461.188 128.061 468.683 128.061 471.614C128.061 473.947 128.506 473.95 138.596 471.672C162.741 466.219 182.348 456.629 193.375 444.877C200.199 437.603 201.801 433.586 201.853 423.618C201.887 417.098 201.658 415.733 199.896 411.982C197.027 405.877 191.804 400.801 180.292 392.932C165.209 382.621 158.767 374.32 156.987 362.904C155.527 353.537 157.221 346.928 165.565 329.44C174.202 311.338 176.342 303.624 177.79 285.378C178.725 273.589 180.02 268.94 183.407 265.209C186.939 261.317 190.119 260 198.861 258.805C213.113 256.858 222.188 253.171 229.648 246.297C236.119 240.334 238.827 234.588 239.243 225.938L239.558 219.382L235.942 215.166C222.846 199.896 40.85 0 40.044 0C39.8719 0 44.1813 5.40178 49.6202 12.0031ZM135.412 409.18C138.373 403.937 136.8 397.195 131.847 393.902C127.167 390.79 119.897 392.256 119.897 396.311C119.897 397.548 120.582 398.449 122.124 399.243C124.72 400.579 124.909 402.081 122.866 405.152C120.797 408.262 120.964 410.996 123.337 412.854C127.162 415.849 132.576 414.202 135.412 409.18Z" fill="#B3B3B3"></path><path fillRule="evenodd" clipRule="evenodd" d="M248.552 262.244C241.862 264.299 235.358 271.39 233.344 278.826C232.116 283.362 232.813 291.319 234.653 293.776C237.625 297.745 240.499 298.791 248.282 298.736C263.518 298.63 276.764 292.095 278.304 283.925C279.567 277.229 273.749 267.948 265.736 263.874C261.601 261.772 252.807 260.938 248.552 262.244ZM266.364 276.172C268.714 272.834 267.686 269.225 263.69 266.785C256.08 262.138 244.571 265.983 244.571 273.173C244.571 276.752 250.572 280.656 256.074 280.656C259.735 280.656 264.746 278.473 266.364 276.172Z" fill="#B3B3B3"></path></svg></div>
                    </div> */}

                </div>

                <div className="flex-row">

                    <div onClick={() => openPage("howtobuy")} style={{margin:11}} className="flex-row align center data-panel interactive">
                        How to Buy

                        <div style={{marginLeft:11}} className="svg-icon swap-small" currentitem="false">
                            <svg height="800px" width="800px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 209.869 209.869">

                                <g>
                                    <path d="M186.143,37.684H47.186c-13.084,0-23.726,9.734-23.726,21.7v1.902C10.5,61.421,0,71.091,0,82.973v67.511
                                        c0,11.966,10.644,21.7,23.726,21.7h138.957c13.082,0,23.726-9.734,23.726-21.7v-1.902c12.957-0.132,23.46-9.802,23.46-21.687
                                        V59.385C209.872,47.419,199.225,37.684,186.143,37.684z M171.195,150.484c0,3.515-3.896,6.482-8.509,6.482H23.729
                                        c-4.613,0-8.509-2.967-8.509-6.482v-67.51c0-3.513,3.898-6.482,8.509-6.482h138.957c4.613,0,8.509,2.97,8.509,6.482V150.484z
                                         M186.412,133.356V82.973c0-11.966-10.644-21.7-23.726-21.7H38.677v-1.889c0-3.513,3.898-6.482,8.509-6.482h138.957
                                        c4.613,0,8.509,2.97,8.509,6.482v67.511h0.003C194.654,130.339,190.904,133.242,186.412,133.356z"/>
                                    <path d="M93.479,111.028c-6.404-0.763-9.655-1.676-9.655-4.558c0-4.464,6.462-4.946,9.242-4.946c4.091,0,8.615,1.978,10.089,4.41
                                        l0.586,0.971l9.346-4.324l-0.571-1.164c-3.289-6.718-9.12-8.747-13.622-9.572V85.9H87.962v5.914
                                        c-9.627,1.499-15.336,6.921-15.336,14.654c0,12.724,11.935,14.058,19.825,14.943c7.172,0.847,10.515,2.569,10.515,5.417
                                        c0,5.509-7.781,5.937-10.168,5.937c-5.351,0-10.505-2.65-11.986-6.168l-0.495-1.169l-10.14,4.296l0.5,1.169
                                        c2.853,6.68,8.968,10.893,17.282,11.943v6.409H98.89v-6.729c7.979-0.984,15.666-6.087,15.666-15.691
                                        C114.559,113.628,101.876,112.065,93.479,111.028z"/>
                                </g>

                            </svg>
                        </div>
                    </div>


                    <button disabled={true} onClick={() => openPage("buy0xdex")} style={{margin:11}} className="flex-row align center data-panel interactive outline">
                        Documentation
                      
                    </button>



                </div>

                <div style={{marginTop:22,marginBottom:44}} className="flex-row">
                    <a target="_blank" href="http://www.0xdex.ai/0xdex_whitepaper_v1.pdf">Download Whitepaper</a>
                </div>

                {/* <hr style={{width:'70%',marginTop:77}} /> */}

                {/* <div style={{marginTop:3}} className="flex-row align center">
                    <div style={{fontSize:22,marginTop:3,marginRight:11,color: "green"}} className="icon-check"/>
                    <div style={{marginRight:11,width:33,height:33}} className="svg-icon">
                        <NftIcon/>
                    </div>
                    <h2 style={{margin:0}}>ERC-721 Token</h2>
                    <div style={{transform: 'scale(.44)', opacity:.77, maxWidth:122}} className="content-panel-element">

                        <img style={{maxWidth:'100%'}} src={require(`../../media/photos/ethereum_logo.png`)}/>

                    </div>
                </div>

                <div ref={animateRefs[11]} style={{paddingTop:0}} className="animate-container transition-long">
                    <div className="slide-in-text">
                        <div className="flex-row">
                            <h4 style={{paddingRight:22}}>Platform access</h4>
                            <p style={{flex:4}}>NFTs (ERC-721) will be available to mint before app launch first of Q4 2023. At that time we will be airdropping 100 NFTs to the top holders of the ERC-20 token respectively. Holding one of these will provide perpetual access to the platform.<br/><br/>The breakdown of access levels and the associative tokenomics is forthcoming.<br/><br/></p>

                        </div>

                    </div>

                </div> */}





            </div>













            <div className="footer-panel">
                    {/*<GridCanvas mouseX={mouseX} mouseY={mouseY} width={windowDimensions.width+100} height={444}/>
*/}
                    <div className="footer-wrapper">
                        <div className="flex-column justify space-between">
                            <div style={{maxWidth:144, margin:8}}>
                                <img style={{marginTop:0,maxWidth:'100%'}} src={logo0x} alt="0xdex logo" />
                            </div>
                            <div className="flex-row">
                                <TokenToolbar addClass="large" slinks={socialLinks}/>
                            </div>
                        </div>

                        {/*<div style={{alignItems:'center', marginLeft:13}} className="flex-row justify space-between">
                            <p style={{display:'flex',opacity:.77,fontSize:11,fontWeight:'600'}}>
                                Made with &nbsp;<span className="icon-button-heart"/> in USA
                            </p>

                        </div>*/}

                    </div>

                    <div className="footer-image-container">

                    {/*{ heroImage && (
                        <div ref={parallaxRefs[0]}
                        style={{
                            backgroundImage:`url(${require(`../../media/photos/${heroImage}`)})`,
                            backgroundSize: 'cover',
                            transitionDelay:'0 !important'
                            // filter: 'saturate(0) contrast(1.3)'
                        }}
                        className="parallax-image animate-off"/>

                    )}*/}

                        { heroImage && (
                            <div ref={footerImageRef}
                            style={{
                                backgroundImage:`url(${require(`../../media/photos/${heroImage}`)})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'bottom',
                                transitionDelay:'0 !important'
                                // filter: 'saturate(0) contrast(1.3)'
                            }}
                            className="footer-image animate-off"/>

                        )}
                        <div style={{height:"100%",zIndex:2,top:0,borderTop:'2px solid #171717'}} className="ticker-overlay animate-off"></div>


                    </div>

                    <div className="copyright">
                        <p style={{fontSize:11,fontWeight:'600'}}>
                            <span className="small mute">© Copyright {new Date().getFullYear()} 0xdex.ai &nbsp; All Rights Reserved.</span>
                        </p>
                    </div>


            </div>

        </Layout>
    );
}
